<!-- <div mat-dialog-title class="flex justify-between  items-center" cdkDrag cdkDragRootElement=".cdk-overlay-pane" -->

<div class="bg-linear-to-r from-teal-700 via-cyan-600 to-emerald-600 flex justify-between items-center h-11 px-4 shadow-md cursor-move text-white border-b border-white/20"
  #header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
  <div class="flex items-center space-x-3">
    <mat-icon class="text-white/85 w-5! h-5! text-[20px]! leading-none">grid_view</mat-icon>
    <span class="font-bold antialiased text-sm overflow-hidden text-ellipsis whitespace-nowrap max-w-100">
      {{label()}}
    </span>
  </div>
  <div class="flex items-center space-x-3">
    <button (click)="doOk($event)"
      class="flex items-center space-x-1 px-3 py-1 bg-white/20 hover:bg-white/30 active:bg-white/40 transition-all duration-200 rounded text-xs font-medium border border-white/30 backdrop-blur-sm">
      <mat-icon class="w-4! h-4! text-[16px]! leading-none!">check</mat-icon>
      <span>確定</span>
    </button>
    <button (click)="doCancel($event)"
      class="flex items-center space-x-1 px-3 py-1 bg-rose-500/90 hover:bg-rose-600 active:bg-rose-700 transition-all duration-200 rounded text-xs font-medium shadow-sm">
      <mat-icon class="w-4! h-4! text-[16px]! leading-none!">close</mat-icon>
      <span>取消</span>
    </button>
  </div>
</div>
<div class="bg-slate-50 border-b border-slate-200 px-3 py-2">
  <div class="flex flex-wrap items-center gap-2">
    <div class="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1 shadow-sm">
      <span class="text-xs font-semibold text-slate-600 whitespace-nowrap">重查</span>
      <app-jkcombobox #search1 class="min-w-50" [styleDisplay]="'flex'" [items]="orderList"
        [(value)]="orderItemId">
      </app-jkcombobox>
      <app-jkcombobox class="min-w-45" [styleDisplay]="'flex'" [items]="compareList"
        [(value)]="orderCompareId">
      </app-jkcombobox>
      <app-jkedit class="min-w-30 rounded border border-blue-200 bg-blue-50/60 px-1" #idOrderWhere
        placeholder="重查資料" [width]="80" [showClearButton]="false" [(value)]="orderWhere"
        (keydown.enter)="$event.preventDefault(); orderWhere = idOrderWhere.value; doRefresh()">
      </app-jkedit>
      <button class="btn min-h-8" [class.btn-primary]="true" [class.btn-small]="true" (click)="orderWhere = idOrderWhere.value; doRefresh()">
        <mat-icon class="w-4! h-4! text-[16px]!">search</mat-icon>
        <span>重查</span>
      </button>
    </div>

    <div class="flex items-center gap-1 rounded-md border border-slate-200 bg-white px-2 py-1 shadow-sm">
      <span class="min-w-12 rounded bg-slate-100 px-2 py-1 text-center text-xs font-semibold text-slate-700">
        {{itemList.length}} 筆
      </span>
      <button class="w-8! h-8! text-slate-600 hover:text-blue-700" matSuffix mat-icon-button
        (click)="gridSrv.goFirstRow()" matTooltip="第一筆">
        <mat-icon>first_page</mat-icon>
      </button>
      <button class="w-8! h-8! text-slate-600 hover:text-blue-700" matSuffix mat-icon-button aria-label="open win"
        [matTooltip]="openwinItemStr()">
        <mat-icon>more_vert</mat-icon>
      </button>
      <button class="w-8! h-8! text-slate-600 hover:text-blue-700" matSuffix mat-icon-button
        (click)="gridSrv.goLastRow()" matTooltip="最後一筆">
        <mat-icon>last_page</mat-icon>
      </button>
      <button class="w-8! h-8! text-slate-600 hover:text-blue-700" matSuffix mat-icon-button (click)="onSumAll()"
        matTooltip="總計">
        <mat-icon>summarize</mat-icon>
      </button>
    </div>

    <div class="flex items-center gap-2 rounded-md border border-slate-200 bg-white px-2 py-1 shadow-sm">
      <span class="text-xs font-semibold text-slate-600 whitespace-nowrap">快篩</span>
      <app-jkedit class="min-w-40 rounded border border-slate-200 px-1" placeholder="其中包含..."
        [width]="100" [showClearButton]="false" [(value)]="gridFilterValue"
        (valueChange)="onFilterTextBoxChanged($event)">
      </app-jkedit>
    </div>
  </div>
</div>

<div class="w-full h-[calc(100%-89px)] min-h-90] bg-white">
  <ag-grid-angular [theme]="gridSrv.theme" style="width: 100%;height: 100%;" [rowData]="itemList" [rowSelection]="gridSrv.rowSelection"
    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [pagination]="false"
    [localeText]="gridSrv.localeText" (onSelectionChanged)="onSelectionChanged()" (rowClicked)="agRowClicked($event)"
    (rowDoubleClicked)="agRowDoubleClicked($event)" (gridReady)="onGridReady($event)">
  </ag-grid-angular>

</div>
